// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"691":"stripe-express","700":"shop-chat"}[chunkId] + "." + {"691":"aa577d4f","700":"b060f742"}[chunkId] + ".js";
};